import { useQuery } from '@hooks/reactQuery';

import { getDownloadHistory } from '@api/downloadHistory';

import { extractQueryParams } from '@utils/common';

import { IDownloadHistoryDTO, IDownloadHistoryItem } from '@interfaces/downloadHistory/downloadHistoryDTO';

import { refetchOptions } from '@constants/common';
import { allowedRolesDownloadHistory } from '@constants/downloadHistory';
import { DOWNLOAD_HISTORY } from '@constants/queryKeys';

interface IUseQueryDownloadHistoryReturned {
	downloadHistory: IDownloadHistoryItem[];
	countOfRecords: number;
	isLoadingDownloadHistory: boolean;
}

export const useQueryDownloadHistory = (
	params: IDownloadHistoryDTO,
): IUseQueryDownloadHistoryReturned => {
	const {
		page,
		pageSize,
	} = params;

	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [DOWNLOAD_HISTORY, params],
		allowedRoles: allowedRolesDownloadHistory,
		queryFn: extractQueryParams(getDownloadHistory),
		enabled: [!!page, !!pageSize],
		...refetchOptions,
	});

	return {
		downloadHistory: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingDownloadHistory: (isLoading && !!data)
			|| isFetching,
	};

};
